import { createFeatureSelector, createSelector } from '@ngrx/store'
import { ClockInClockOutState } from './clockIn-clockOut.state'

export const selectClockInClockOutState =
  createFeatureSelector<ClockInClockOutState>('clockInClockOut')

export const selectIsPunchedIn = createSelector(
  selectClockInClockOutState,
  state => state.isPunchedIn ?? false
)

// Selector to get the total count of businesses
export const selectTotalCount = createSelector(
  selectClockInClockOutState,
  (state: ClockInClockOutState) => {
    // console.log('ClockInClockOutState:', state)
    return state.totalCount
  }
)

// Selector to get the total count of businesses
export const selectTotalWorkHoursThisWeek = createSelector(
  selectClockInClockOutState,
  (state: ClockInClockOutState) => state.totalWorkHoursThisWeek
)

// Selector to get the total count of businesses
export const selectTotalWorkHoursThisMonth = createSelector(
  selectClockInClockOutState,
  (state: ClockInClockOutState) => state.totalWorkHoursThisMonth
)

export const selectTotalWorkHoursToday = createSelector(
  selectClockInClockOutState,
  (state: ClockInClockOutState) => state.totalWorkHoursToday
)

export const selectTodaysClockinoutRecords = createSelector(
  selectClockInClockOutState,
  (state: ClockInClockOutState) => state.todaysClockinoutRecords
)

export const selectTotalProductiveWorkHoursToday = createSelector(
  selectClockInClockOutState,
  (state: ClockInClockOutState) => state.totalProductiveWorkHoursToday
)

export const selectTotalBreakHoursToday = createSelector(
  selectClockInClockOutState,
  (state: ClockInClockOutState) => state.totalBreakHoursToday
)

export const selectExpectedWorkHoursToday = createSelector(
  selectClockInClockOutState,
  s => s.expectedWorkHoursToday
)

export const selectExpectedWorkHoursThisWeek = createSelector(
  selectClockInClockOutState,
  s => s.expectedWorkHoursThisWeek
)

export const selectExpectedWorkHoursThisMonth = createSelector(
  selectClockInClockOutState,
  s => s.expectedWorkHoursThisMonth
)

export const selectTotalOvertimeToday = createSelector(
  selectClockInClockOutState,
  (state: ClockInClockOutState) => state.totalOvertimeToday
)

export const selectTotalOvertimeThisMonth = createSelector(
  selectClockInClockOutState,
  (state: ClockInClockOutState) => state.totalOvertimeThisMonth
)

// export const selectDesignationId = createSelector(selectDesignationState, (state: designationState) =>
//   state.designations.length > 0 ? state.designations[state.designations.length - 1].id : null
// )
export const selectAdminAttendanceData = createSelector(selectClockInClockOutState, state => ({
  totalCount: state.totalCount,
  clockinclockouts: state.clockinclockouts,
  adminData: state.adminData
}))
